import { render, staticRenderFns } from "./PlanosRegistro.vue?vue&type=template&id=1f9de007&scoped=true"
import script from "./PlanosRegistro.vue?vue&type=script&lang=js"
export * from "./PlanosRegistro.vue?vue&type=script&lang=js"
import style0 from "./PlanosRegistro.vue?vue&type=style&index=0&id=1f9de007&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9de007",
  null
  
)

export default component.exports